/** 事件等级（与 /safeevent/list 请求筛选、列表 event_level 一致：1-低危, 2-中危, 3-高危） */
export enum SecurityEventLevel {
  Low = 1,
  Medium = 2,
  High = 3,
}

/** 处置状态（与 /safeevent/list handle_status 一致：1-未处置, 2-已信任, 3-已处置, 4-已忽略） */
export enum SecurityDisposeStatus {
  Pending = 1,
  Trusted = 2,
  Handled = 3,
  Ignored = 4,
}

/** 事件类型（与 PRD 一致） */
export enum SecurityEventType {
  ProgramRun = 1,
  DriverLoad = 2,
  Registry = 3,
  AntiInject = 4,
  SystemKeyPoint = 5,
  DesktopProtect = 6,
  Ransomware = 7,
  AntiTrojanDownload = 8,
  AntiRemoteControl = 9,
  AntiWorm = 10,
  ThreatLink = 11,
  BruteForce = 12,
  FilelessAttack = 13,
  MemoryProtect = 14,
}

/** 列表接口处置结果（/safeevent/list handle_result） */
export enum SafeEventHandleResult {
  Blocked = 1,
  Isolated = 2,
  Alerted = 3,
}

/** 处置结果（可多选） 0-已放行 1-拒绝执行 2-拒绝执行并结束进程 3-封堵域名 4-封堵IP 5-结束进程 6-添加信任 */
export enum SecurityDisposeResult {
  Allowed = 0,
  DenyExecute = 1,
  DenyExecuteAndKill = 2,
  BlockDomain = 3,
  BlockIp = 4,
  KillProcess = 5,
  AddTrust = 6,
}

/** ATT&CK 战术阶段 */
export enum AttackStage {
  InitialAccess = 1,
  Execution = 2,
  Persistence = 3,
  PrivilegeEscalation = 4,
  DefenseEvasion = 5,
  CredentialAccess = 6,
  Discovery = 7,
  LateralMovement = 8,
  Collection = 9,
  CommandAndControl = 10,
  Exfiltration = 11,
  Impact = 12,
}

/** 接口 threat_type（/safeevent/list、详情） */
export enum ApiThreatType {
  File = 1,
  Process = 2,
  Ip = 3,
  BehaviorHash = 4,
  Url = 5,
  User = 6,
}

/** UI 威胁实体类型（与 ApiThreatType 数值不同，仅供前端分支） */
export enum ThreatEntityType {
  Ip = 1,
  Url = 2,
  Process = 3,
  BehaviorHash = 4,
  File = 5,
  User = 6,
}

/** ApiThreatType → ThreatEntityType */
export const API_THREAT_TYPE_TO_ENTITY: Record<ApiThreatType, ThreatEntityType> = {
  [ApiThreatType.File]: ThreatEntityType.File,
  [ApiThreatType.Process]: ThreatEntityType.Process,
  [ApiThreatType.Ip]: ThreatEntityType.Ip,
  [ApiThreatType.BehaviorHash]: ThreatEntityType.BehaviorHash,
  [ApiThreatType.Url]: ThreatEntityType.Url,
  [ApiThreatType.User]: ThreatEntityType.User,
}

/** IP 策略：与 ip-address-blocking ProtocolState / DirectionState 一致 */
export enum BlockProtocol {
  Any = 1,
  Tcp = 2,
  Udp = 3,
}

export enum BlockDirection {
  Bidirectional = 1,
  Inbound = 2,
  Outbound = 3,
}

/** 分布图维度 */
export enum DistributionDimension {
  Level = 'level',
  Category = 'category',
  AttackStage = 'attack_stage',
}

/** 处置方式 */
export enum DisposeActionType {
  BlockIp = 'block_ip',
  BlockUrl = 'block_url',
  IsolateFile = 'isolate_file',
  KillProcess = 'kill_process',
  MarkHandled = 'mark_handled',
  MarkIgnored = 'mark_ignored',
  TrustIp = 'trust_ip',
  TrustUrl = 'trust_url',
  TrustProcess = 'trust_process',
  TrustHash = 'trust_hash',
  TrustFile = 'trust_file',
}

/** 应用范围 */
export enum ApplyScope {
  Local = 0,
  AllEndpoints = 1,
}

export const DEFAULT_PENDING_STATUS = SecurityDisposeStatus.Pending

/** 处置日志动作（/safeevent/detail log.data_type） */
export enum SafeEventHandleLogAction {
  Block = 1,
  Handled = 2,
  Ignore = 3,
  Trust = 4,
  Isolate = 5,
  CancelTrust = 6,
  CancelIgnore = 7,
}
